<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.awards.' + listitemId + '.data.name'"
            :data-default="{ type: 'raw', value: 'Ihre Auszeichnung' }"
            required
            :maxlength="255"
        ></app-text>

        <app-filepicker
            label="Datei Hochladen"
            :data-source="'deha.user.misc.awards.' + listitemId + '.data.file'"
            accept=".pdf,.zip"
        ></app-filepicker>

        <app-checkbox
            label="Link"
            :data-source="'deha.user.misc.awards.' + listitemId + '.data.linkActive'"
            revalidate-source="link"
        ></app-checkbox>

        <app-text
            v-show="
                getProp('deha.user.misc.awards.' + listitemId + '.data.linkActive') == 1
            "
            :required="
                getProp('deha.user.misc.awards.' + listitemId + '.data.linkActive') == 1
            "
            label="Titel des links"
            :data-source="'deha.user.misc.awards.' + listitemId + '.data.linkText'"
            :data-default="{ type: 'textpicker' }"
            textpicker-namespace="misc/link"
            :maxlength="255"
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>

        <app-text
            v-show="
                getProp('deha.user.misc.awards.' + listitemId + '.data.linkActive') == 1
            "
            :required="
                getProp('deha.user.misc.awards.' + listitemId + '.data.linkActive') == 1
            "
            label="Link zur Website"
            :data-source="'deha.user.misc.awards.' + listitemId + '.data.link'"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R055'),
            help: this.$helpers.uiText('R056'),
            removeText: this.$helpers.uiText('R058')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-filepicker': Filepicker,
        'app-checkbox': Checkbox
    }
};
</script>
